import { render, staticRenderFns } from "./MetadataIndex.vue?vue&type=template&id=6c91e010&scoped=true"
import script from "./MetadataIndex.vue?vue&type=script&lang=js"
export * from "./MetadataIndex.vue?vue&type=script&lang=js"
import style0 from "./MetadataIndex.vue?vue&type=style&index=0&id=6c91e010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c91e010",
  null
  
)

export default component.exports